const selectGroups = (state) => state.reviewCompetencies.groups;

const reviewCompetenciesSelectors = {
  selectGroups,
};

export default reviewCompetenciesSelectors;
